import React from 'react';
import Button from '@material-ui/core/Button';
import translations from './translations';
import { FormattedMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import formatCurrency from '@afosto/utils/formatCurrency';
import InvoiceInfo from './InvoiceInfo';

export const actionsFormatter = (cell, row) => (
  <Grid container spacing={1} wrap="nowrap">
    {row?.pdf && (
      <Grid item>
        <Button href={row.pdf} target="_blank" variant="outlined" size="small">
          <FormattedMessage {...translations.formatters.downloadPdf} />
        </Button>
      </Grid>
    )}
    {!row?.is_paid && row?.payment_url && (
      <Grid item>
        <Button
          href={row.payment_url}
          target="_blank"
          variant="contained"
          color="primary"
          size="small"
        >
          <FormattedMessage {...translations.formatters.paymentUrl} />
        </Button>
      </Grid>
    )}
  </Grid>
);

export const totalFormatter = (cell, row) => formatCurrency(row.total / 100);

export const invoiceInfoFormatter = (cell, row) => <InvoiceInfo invoice={row} />;

export default actionsFormatter;
